import React from 'react';

export default function ReportBudget() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Report Budget vs Actual</h1>
      <p className="text-gray-500">Halaman Report Budget vs Actual</p>
    </div>
  );
}
